<div class="subBlockContainer" id="createtenant">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="chid-body">
      <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->
        <div [formGroup]="userFormGroup">
          <div class="container" formGroupName="userGroup">
            <div class="row">
              <div class="userinfo col-md-6">
                <mat-form-field [floatLabel]="'always'">
                  <input matInput class="domainPrefixValidate" formControlName="prefixField" (blur)="checkPrefix()"
                    placeholder="DOMAIN PREFIX" required>
                  <span matSuffix>.onmicrosoft.com</span>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'">
                  <input matInput class="userNameValidate" formControlName="userNameField" placeholder="USER NAME" requried>
                  <mat-icon matSuffix class="usernameicon" placement="bottom" ngbTooltip="Default login is admin">info
                  </mat-icon>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'">
                  <input matInput class="firstNameValidate" formControlName="firstNameField" placeholder="FIRST NAME"
                    required>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'">
                  <input matInput class="lastNameValidate" formControlName="lastNameField" placeholder="LAST NAME" required>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'">
                  <input matInput class="companyNameValidate" formControlName="companyNameField" placeholder="COMPANY NAME"
                    required>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'">
                  <input matInput class="emailValidate" formControlName="emailField" placeholder="EMAIL (Please Use A Current Valid Address)" required>
                </mat-form-field>
              </div>
              <div class="userinfo col-md-6">
                <mat-form-field [floatLabel]="'always'">
                  <input id ="addressLine1" matInput class="addressLine1Validate" formControlName="addressLine1Field"
                  (change)="omit_nonprintable_char($event)" placeholder="ADDRESS LINE 1" required>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'">
                  <input id ="addressLine2" matInput class="addressLine2Validate" formControlName="addressLine2Field"
                  (change)="omit_nonprintable_char($event)" placeholder="ADDRESS LINE 2">
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'">
                  <input id ="addressLine3" matInput class="addressLine3Validate" formControlName="addressLine3Field"
                  (change)="omit_nonprintable_char($event)" placeholder="ADDRESS LINE 3">
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'">
                  <input matInput class="suburbValidate" #myAutocompleteTriggerSub="matAutocompleteTrigger"
                    (input)="onInputSub($event)" [matAutocomplete]="autoSuburb" formControlName="suburbField"
                    placeholder="SUBURB" (keydown.Tab)="chooseAutoCompletSuburb($event)" (suburb)="startFilterSub($event)" 
                    required>
                  <mat-autocomplete #autoSuburb="matAutocomplete">
                    <mat-option *ngFor="let option of filteredSub" [value]="option?.suburb"
                      (click)="chooseAutoComplete(option)">
                      {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <!-- <mat-form-field [floatLabel]="'always'">
                  <mat-select class="stateValidate" placeholder="State" formControlName="stateField" required>
                    <mat-option value="{{state}}" *ngFor="let state of stateList">{{state}}</mat-option>
                  </mat-select>
                </mat-form-field> -->
                <ng-select style="margin-top: 30px;" class="customDropdwon stateValidate" [items]="stateList" bindValue="state" bindLabel="state"
                  placeholder="State *" formControlName="stateField"></ng-select>
                <mat-form-field [floatLabel]="'always'">
                  <input matInput class="postcodeValidate" #myAutocompleteTriggerPostcode="matAutocompleteTrigger"
                    (input)="onInputPostcode($event)" maxlength="4" (keypress)="isNumberKey($event)"
                    formControlName="postcodeField" (postcode)="startFilterPostcode($event)"
                    (keydown.Tab)="chooseAutoCompletPostcode($event)" [matAutocomplete]="autoPostcode"
                    placeholder="POST CODE" required>
                  <mat-autocomplete #autoPostcode="matAutocomplete">
                    <mat-option *ngFor="let option of filteredPostCode" [value]="option?.postcode"
                      (click)="chooseAutoComplete(option)">
                      {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'">
                  <input matInput (keypress)="isNumberKey($event)" class="phoneValidate" formControlName="phoneField"
                    placeholder="PHONE" required>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row" *ngIf="tenantId != ''">
          <div class="userinfo col-md-6" *ngIf="companyCode==='T01' || companyCode==='1'">
            <div class="payment-title">Payment Method</div>
            <div id="list-payment">
              <div class="noData-wrapper" *ngIf="!paymentList?.length">
                <div>
                  <img src="../images/new_ui/no-wallet.png">
                </div>
                <div class="noData-label">Your digital wallet is empty.</div>
                <div class="button-center">
                  <button id="addPaymentBtn" class="button button-red button-large"
                    (click)="navigateToDigitalWallet()">Create new</button>
                </div>
              </div>

              <ng-container *ngIf="paymentList?.length">
                <div class="row margin-top-30 dropdownBox">
                  <div class="col-sm">
                    <label class="po-label">Select a payment from your wallet</label><br />
                    <button class="button button-red button-mid reset-payment" (click)="resetPayment()">Reset Payment
                      Option</button>
                    <mat-form-field>
                      <mat-select [(value)]="selectedPayment" (change)="selectPaymentMethod();">
                        <mat-option value="{{payment.value}}" *ngFor="let payment of paymentList">{{payment.text}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div> -->
        <div class="button-center">
          <!-- <button class="button button-red button-large" *ngIf="tenantId != ''" (click)="navigateToDetailsPage()">Manage Details</button> -->
          <button
            *ngIf="tenantId == ''"
            class="button button-red button-large"
            [disabled]="!checkDomain || (!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess)"
            [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
            matTooltip="Requires Purchasing Permissions"
            (click)="saveEndUser()"
          >Create</button>
        <loading-screen *ngIf="!loadContent" [isChildLoader]="true" [showBlurTable]="false"></loading-screen>
        </div>
      </div>
    </div>
  </div>
</div>
